import { render, staticRenderFns } from "./AccountConfig.vue?vue&type=template&id=1593c084&scoped=true&"
import script from "./AccountConfig.vue?vue&type=script&lang=js&"
export * from "./AccountConfig.vue?vue&type=script&lang=js&"
import style0 from "./AccountConfig.vue?vue&type=style&index=0&id=1593c084&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1593c084",
  null
  
)

export default component.exports